module.exports = __webpack_public_path__ + "img/icon-manage.3e667106.svg";